import { Coins } from 'lucide-react';
import { cn } from '@lib/utils';
import { useAiDurum } from './hooks/useAi';

/**
 * Son kullanıcıya yönelik SADE kredi göstergesi: "AI Kredi: 20/50"
 * (kullanılan/toplam). Bilinçli olarak yalnız sayı gösterir —
 * TL tutarı, tavan, grafik veya teknik detay YOKTUR.
 * AI yapılandırılmamışsa veya durum yüklenemediyse hiç render edilmez.
 */
export function AiKrediChip({ className }: { className?: string }) {
  const { data: durum } = useAiDurum();
  if (!durum?.yapilandirildi) return null;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border bg-muted/50 px-2.5 py-1 text-xs font-medium text-muted-foreground',
        className,
      )}
      title={`Kullanılan / toplam AI kredisi — kalan: ${durum.kredi.kalan}`}
    >
      <Coins className="h-3.5 w-3.5 text-primary" />
      AI Kredi: {durum.kredi.kullanilan}/{durum.kredi.toplam}
    </span>
  );
}
